
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      configuration: {
        title: null,
        message: null,
        htmlText: null,
        callback: null,
        buttons: null,
        noButtonLabel: 'No',
        yesButtonLabel: 'Yes',
        deleteMode: false,
        bulkAction: false,
        showWarning: false,
        warningMessage: 'Warning: This action cannot be undone.',
        customComponent: null,
        customProps: null,
        showCloseIcon: false,
        customData: null,
        beiqProfiler: false,
        enterPasswordMode: false,
        preventAutoClose: false,
      },
      isOpen: false,
      confirmWord: null,
      password: null,
    };
  },
  computed: {
    dialogueWidth() {
      if (this.configuration.size?.width === 'small') {
        return 'max-w-lg';
      } else {
        return 'max-w-max';
      }
    },
    gridColumns() {
      const numberOfButtons = this.modalButtons.length;
      return `grid-cols-${numberOfButtons}`;
    },
    canProceed() {
      if (this.configuration.deleteMode === true) {
        return this.confirmWord === 'delete';
      } else if (this.configuration.bulkAction === true) {
        return this.confirmWord === 'action';
      } else {
        return true;
      }
    },
    modalButtons() {
      let buttons = [];
      if (this.configuration.buttons.length === 0) {
        buttons.push({
          label: this.configuration.hideNoButton ? 'OK' : this.configuration.yesButtonLabel || 'Yes',
          isCancel: false,
          disabled: !this.canProceed,
          class: `text-p-green hover:bg-p-green-pale hover:text-p-green-dark ${
            this.configuration.hideNoButton ? 'col-span-2' : ''
          } ${!this.canProceed ? 'disabled cursor-not-allowed' : ''}`,
          callback: () => {
            if (this.configuration.callback) {
              this.confirmWord = null;
              if (this.configuration.customData) {
                this.configuration.callback(this.configuration.customData);
              } else if (this.configuration.enterPasswordMode) {
                this.configuration.callback(this.password);
                this.password = null;
              } else {
                this.configuration.callback();
              }
            }

            if (!this.configuration.preventAutoClose) {
              this.isOpen = false;
            }
          },
        });
      } else {
        buttons = this.configuration.buttons;
      }

      if (!this.configuration.hideNoButton) {
        buttons.unshift({
          label: this.configuration.noButtonLabel || 'No',
          isCancel: true,
          disabled: false,
          class: 'text-p-pink hover:bg-p-pink-pale hover:text-p-pink-dark',
          callback: () => {
            this.isOpen = false;
            this.confirmWord = null;
          },
        });
      }

      return buttons;
    },
  },
  mounted() {
    this.$nuxt.$on('confirm', this.open);
    this.$nuxt.$on('confirmDialogError', this.handleFormErrors);
    this.$nuxt.$on('closeConfirmDialog', () => {
      this.close();
    });
  },
  beforeDestroy() {
    this.$nuxt.$off('confirm');
    this.$nuxt.$off('confirmDialogError');
    this.$nuxt.$off('closeConfirmDialog');
  },
  methods: {
    open(config) {
      if (!config.buttons) {
        config.buttons = [];
      }

      this.configuration = {
        ...this.configuration,
        ...config,
        customProps: config.customProps || {},
        customData: config.customData || null,
      };
      this.password = null;
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
      this.configuration = {
        title: null,
        message: null,
        htmlText: null,
        callback: null,
        buttons: null,
        noButtonLabel: 'No',
        yesButtonLabel: 'Yes',
        deleteMode: false,
        bulkAction: false,
        showWarning: false,
        warningMessage: 'Warning: This action cannot be undone.',
        customComponent: null,
        customProps: null,
        customData: null,
        beiqProfiler: false,
        enterPasswordMode: false,
        preventAutoClose: false,
      };
      this.password = null;
      this.confirmWord = null;
    },
    handleButtonClick(button) {
      if (button.callback) {
        if (this.configuration.customData) {
          button.callback(this.configuration.customData);
        } else {
          button.callback(button.value);
        }
      }

      if (!this.configuration.preventAutoClose || button.isCancel) {
        this.close();
      }
    },
    handleCustomEvent(data) {
      this.configuration.customData = data;
    },
    async clickToCopy(text, alert) {
      await navigator.clipboard.writeText(text);
      this.$nuxt.$emit('notification', alert);
    },
    handleFormErrors(data = {}) {
      const { errors, context } = data;

      if (context === 'password_error' && errors?.password) {
        this.$refs.passwordRef.setErrors(errors.password);
      }
    },
  },
};
